import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { NavPageWrapper } from '../common/Nav';
import { CoachingTable } from './';
import { AlertModal } from 'AlertModal';

export default class AgentCoaching extends Component {

  state = {
    showCorporateAlert: true,
    showAgentCoachings: true,
  }

  toggleAgentCoaching = () => {
    this.setState((prevState) => ({
      showAgentCoachings: !prevState.showAgentCoachings
    }));
  }

  render() {
    const { isCorporateUser, isManager } = this.props;
    const { showAgentCoachings } = this.state;
    const path = this.props.match.path;
    const title = `View ${showAgentCoachings ? ' Triad Coaching / Process Flow Evaluation' : ' Agent Coaching'}`;

    return (
      <div>
        <NavPageWrapper currPath={path}>
          <div className="agent-coaching">
            <div className='header-row'>
              <h6>Coaching Opportunities</h6>
              {isManager && (
                <button 
                  className='toggle-btn'
                  onClick={this.toggleAgentCoaching}
                >
                    {title}
                </button>
              )}
              <Link
                className={isCorporateUser ? 'create-btn disabled' : 'create-btn'}
                to={isCorporateUser ? "#" : "/AgentCoaching/Opportunity"}
              >
                New Coaching Opportunity
              </Link>
            </div>
            <CoachingTable
              isDisabled={isCorporateUser}
              showAgentCoachings={showAgentCoachings}
            />
            <AlertModal
              className="corporate-alert-modal"
              showModal={this.state.showCorporateAlert && isCorporateUser}
              closeModal={() => this.setState({ showCorporateAlert: false })}
              overlayClassName="alert-overlay"
              height={160}
              width={500}
            >
              <div className="alert-modal-content-cont">
                <p className="alert-modal-header">Agent Portal</p>
                <p className="alert-modal-content">
                Please review the account set up. A valid call center account must be configured in order to continue. For assistance, please reach out to NOC.
                </p>
              </div>
              <div className="alert-modal-button-container">
                <div
                  className={"alert-modal-button accept"}
                  onClick={() => this.setState({ showCorporateAlert: false })}
                >
                  OK
                </div>
              </div>

            </AlertModal>
          </div>
        </NavPageWrapper>
      </div>
    );
  }
}

AgentCoaching.propTypes = {
  location: PropTypes.object.isRequired,
}


// WEBPACK FOOTER //
// ./src/features/agent-coaching/AgentCoaching.js